var _circle, _path, _rect, _line, _circle2, _circle3, _circle4, _circle5, _circle6, _rect2, _line2, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 88,
    viewBox: "0 0 118 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 46.5,
    r: 3.5,
    fill: "#949EB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 31C28 28.7908 29.7909 27 32 27H99C101.209 27 103 28.7908 103 31V32H111C113.209 32 115 33.7908 115 36V38C115 40.2092 113.209 42 111 42H95.6656C92.9526 44.3062 92.6348 48.2988 94.7123 51H114C116.209 51 118 52.7908 118 55V57C118 59.2092 116.209 61 114 61H91.6656C88.5927 63.6122 88.5927 68.3878 91.6656 71H107C109.209 71 111 72.7908 111 75V77C111 79.2092 109.209 81 107 81H6C3.79089 81 2 79.2092 2 77V75C2 72.7908 3.79089 71 6 71H12.3344C15.4073 68.3878 15.4073 63.6122 12.3344 61H4C1.79089 61 0 59.2092 0 57V55C0 52.7908 1.79089 51 4 51H82V42H12C9.79089 42 8 40.2092 8 38V36C8 33.7908 9.79089 32 12 32H28V31ZM78 61V71H26V61H78Z",
    fill: "#F1F3F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 17,
    width: 58,
    height: 70,
    rx: 2,
    fill: "white",
    stroke: "#2B2B45",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 61,
    x2: 60,
    y2: 61,
    stroke: "#2B2B45",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 48.5,
    r: 2.5,
    fill: "#0A0A0A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 48.5,
    r: 2.5,
    fill: "#0A0A0A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0553,
    cy: 21.0552,
    r: 1.5,
    transform: "rotate(1.60469 31.0553 21.0552)",
    fill: "#C4C4C4",
    stroke: "#2B2B45"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0553,
    cy: 21.0552,
    r: 1.5,
    transform: "rotate(1.60469 35.0553 21.0552)",
    stroke: "#2B2B45"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0553,
    cy: 21.0552,
    r: 1.5,
    transform: "rotate(1.60469 39.0553 21.0552)",
    stroke: "#2B2B45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 19.5,
    width: 38,
    height: 3,
    rx: 1.5,
    stroke: "#2B2B45"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 24.5,
    x2: 84,
    y2: 24.5,
    stroke: "#2B2B45"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 7,
    r: 3,
    fill: "#949EB9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 21.5,
    r: 2.5,
    fill: "#E93A4D"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 8,
    r: 2,
    fill: "#949EB9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 2,
    r: 2,
    fill: "#E93A4D"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 16,
    r: 2,
    fill: "#E93A4D"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 47,
    r: 2,
    fill: "#E93A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/Nodata.5682b0633258b3bc3a06ab201c250b8e.svg";
export { ForwardRef as ReactComponent };